import ForgotPassword from "../components/ForgotPassword";

export default function ForgotPasswordPage() {
  return <ForgotPassword />;
}
